<style lang="scss" scoped>
/deep/ .image {
  &-small {
    .dynamic-image {
      height: 186.4px;
    }
  }
  &-medium {
    .dynamic-image {
      height: 267.75px;
    }
  }
  &-large {
    .dynamic-image {
      height: 380px;
    }
  }
}
</style>

<template>
  <div>
    <div class="row mb-ngrid">
      <component :is="`${type}-card`" :class="[colClass, 'mb-grid']" v-for="(item, key) in items" :key="key" :data="item" :url="cardUrl" :url-params="cardUrlParams" data-aos="fade-up" :data-aos-delay="key * 50"></component>
    </div>
    <div class="row">
      <div class="col-12">
        <infinite-loading @infinite="loadData" spinner="waveDots" ref="infiniteLoading">
          <span slot="no-more"></span>
          <span slot="no-results"></span>
          <span slot="spinner">
            <loader></loader>
          </span>
        </infinite-loading>
      </div>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import EstatesCard from '../cards/estate';
import NewsCard from '../cards/news';
import Loader from '../parts/loader';

export default {
  components: {
    InfiniteLoading,
    EstatesCard,
    NewsCard,
    Loader,
  },
  props: {
    type: {
      default: 'estates',
    },
    page: {
      default: 0,
    },
    perPage: {
      default: 20,
    },
    perRow: {
      default: false,
    },
    max: {
      default: 2,
    },
    exclude: {
      default: '',
    },
    categories: {
      default: null,
    },
    hideEstateId: {
      default: '',
    },
    displayStatus: {
      default: '2,3',
    },
    types: {
      default: '',
    },
    cities: {
      default: '',
    },
    filter: {
      default: true,
    },
    projectId: {
      default: null,
    },
    cardUrl: {
      default: null,
    },
    cardUrlParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      items: [],
      p: this.page,
      recommendedMax: this.max,
      loading: false,
    };
  },
  mounted() {
    // check max recommendation
    if (window.innerWidth >= 768 && window.innerWidth < 960) this.recommendedMax = 2;
    if (window.innerWidth >= 960 && window.innerWidth < 1200) this.recommendedMax = 3;

    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.loading) return;
      this.loading = true;
      const fetch = this.perPage >= this.recommendedMax ? this.recommendedMax : this.perPage;
      let params = {
        page: this.p,
        perPage: fetch,
        contentType: this.type,
        exclude: this.exclude,
        categories: this.categories,
        displayStatus: this.displayStatus,
        types: this.types,
        cities: this.cities,
        hideEstateId: this.hideEstateId,
        projectId: this.projectId,
      };
      axios
        .get(`/api/v1/${this.type}`, { params })
        .then((res) => {
          this.loading = false;
          if (this.items.length >= this.recommendedMax) return;

          const data = res.data.data[this.type];
          data.forEach((item) => {
            if (this.type === 'estates' && item.id !== this.hideEstateId) {
              this.items.push(item);
            } else {
              this.items.push(item);
            }
          });

          // If there is no response -> no need to fetch again
          if (data.length === 0) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
            return;
          }

          // If the items we have is equal to the max -> we have enough
          if (this.items.length >= this.recommendedMax) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
            return;
          }

          // If the items we have are less than the max and less then we requested -> there are none left
          if (data.length < fetch) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
            return;
          }

          // If the items we have are less than the max and exacly what we requested -> There might be more
          if (data.length === fetch) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
            this.p++;
            return;
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    loadData: _.debounce(function($state) {
      this.fetchData();
    }, 800),
  },
  computed: {
    colClass() {
      const total = this.items.length;

      if (this.perRow) {
        if (this.perRow === 2) return 'col-12 col-md-6 image-large';
        if (this.perRow === 3) return 'col-12 col-md-6 col-lg-4 image-medium';
        if (this.perRow === 4) return 'col-12 col-md-6 col-lg-4 col-xl-3 mb-grid image-small';
      }

      if (total <= 2) {
        if (window.innerWidth >= 768 && window.innerWidth < 960) return 'col-12 col-md-6 image-small';
        return 'col-12 col-md-6 image-large';
      }

      if (total === 3) {
        if (window.innerWidth >= 960 && window.innerWidth < 1200) return 'col-12 col-md-6 col-lg-4 image-small';
        return 'col-12 col-md-6 col-lg-4 image-medium';
      }

      return 'col-12 col-md-6 col-lg-4 col-xl-3 mb-grid image-small';
    },
  },
};
</script>
